import type { DocumentOrigin, RegisterInput } from './types';

// Cuerpo del alta (G3-2/G3-3). Puro: sin código cuando se acepta el propuesto (el
// servidor asigna el consecutivo bajo bloqueo), con el escrito en un tipo libre o al
// editarlo, el módulo solo en un registro SAP y el dueño solo si se eligió.

export interface RegisterDraft {
  title: string;
  documentTypeId: string;
  processAreaId: string;
  origin: DocumentOrigin;
  sapModule: string;
  code: string;
}

export function registerPayload(
  draft: RegisterDraft,
  mode: { writesCode: boolean; isSap: boolean },
  ownerUserId: string | undefined,
): RegisterInput {
  return {
    ...(mode.writesCode ? { code: draft.code.trim() } : {}),
    ...(mode.isSap ? { sapModule: draft.sapModule } : {}),
    title: draft.title.trim(),
    documentTypeId: draft.documentTypeId,
    processAreaId: draft.processAreaId,
    origin: draft.origin,
    ...(ownerUserId === undefined ? {} : { ownerUserId }),
  };
}
